module.exports = __webpack_public_path__ + "img/empty-search.497eed6.webp";